import { DefaultRootState } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { debounce, Sentry } from '@idk-web/core-utils';
import { LocalStorage } from '@idk-web/core-ui';
import reducer from '@/redux/reducer';

const STORAGE_KEY = 'idk-portal-state-2025-04-29';
const PERSIST_INTERVAL_MS = 1000;

function readState() {
  const state = LocalStorage.getItem(STORAGE_KEY);

  try {
    const parsedState = state ? JSON.parse(state) : undefined;

    // Quickfix for companies which is missing a country array for some reason
    if (parsedState.currentCompany && !parsedState.currentCompany.countries) {
      return undefined;
    }

    return parsedState;
  } catch (e: unknown) {
    Sentry.reportError('Failed to parse redux state', { error: e });
    return undefined;
  }
}

function persistState(state: DefaultRootState) {
  LocalStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

const store = configureStore({
  reducer,
  preloadedState: readState(),
});

store.subscribe(
  debounce(() => {
    persistState(store.getState());
  }, PERSIST_INTERVAL_MS),
);

export default store;
